import React, { useRef, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import InArticlead from './inarticlead';
import { OutbrainWidget, showOutbrainWidget } from 'react-outbrain-widget';
import { Helmet } from 'react-helmet';
import SocialSharing from './socialmediashare';
import SingleContent from './singleContent';
import Chartbeat from './chartbeat';
import Recommended from './related';
import Subcategory from './subcategorylist';
import  useCategoryStories  from "./categorystorylist.js"

const StoryItem = React.forwardRef( (props, ref) =>{

  const {error, loading, items} = useCategoryStories(props.parentname)

  useEffect(()=>{

    console.log(props.parentname + items + "storyitem")

  },[props.parentname])
  
  const  updatecount=(async()=>{
    const articlecount = await fetch('https://www.backend.myjoyonline.com/wp-json/mjo/v1/viewcount?article='+props.guid);
    //console.log(articlecount+props.storyauthor)

  })  
  

    const random_id = Math.random(0,1000000)
    const [listvalue,setListValue] = useState([]);
    let baseurl = window.location.origin;
    //const [adStory, setAdStory] = useState("<h1>Empty</h1>");
    const Listify = () => {
        if(props.tags)
       // console.log(listvalue)
        setListValue(props.tags);
    }
 
   useEffect(()=>{
    Listify();
  },[props.tags]);

  const interactiveStyle = { 
    padding: "10px auto",
    marginBottom: "10px"
  }

  const interactiveStylebottom = { 
   background: "#ffffff",
   border: "8px solid #f7f9f9",
   position: "absolute",
   bottom: "-30px",
   borderRadius: "50px",
   width: "92.5%",
   paddingTop: "0px",
 }





 const attachevuukle = () =>{

  var d = document,
  s = d.createElement('script');
  s.async = true;
  s.src = 'https://cdn.vuukle.com/platform.js';
  (d.head || d.body).appendChild(s);

}

const vkscript = (varticleid, vuukletags, articleauthor) =>{

var vconfig = document.createElement("script")
  //var vkkconfig = document.getElementById("vkkconfig")
var vuconfig = document.createTextNode("var VUUKLE_CONFIG = {apiKey: '255be353-1ccf-4eea-af0c-86d618375550', language: 'en', articleId:'"+ varticleid + "',tags:'" + vuukletags + "',author:'" + articleauthor + "',host:'myjoyonline.com' };");
 vconfig.appendChild(vuconfig);
 document.head.append(vconfig)
 
 attachevuukle();

}

useEffect(()=>{

  if(props.guid != undefined){
    vkscript(props.guid, props.vuukletags, props.storyauthor);
      updatecount();
  }

},[props.guid]);



//date ago function
const dpub = (pdate) =>{
  var dp = new Date(pdate)
 
  return dp.toDateString() + " " + dp.toLocaleTimeString();
}


let st = "";
//let nc = 0;
 const placead = () =>{
  var storycontent = ""
  var n = 0;
  st = props.content.split("</p>");
  for(let g=0; g < st.length; g++){

    if((g % 4 === 0 && g !== 0) && n < 2){
      //let adcon = Math.floor(Math.random()*200000000);

      //storycontent += "<div id='div-gpt-ad-1651994468322-"+adcon+"'><h1>add here</h1></div>";
      
     // dyad("/1002554/Myjoyonline/myjoyonline_in_article_mid", adcon);

      storycontent += st[g];
      n++;

    }else{

      storycontent += st[g];
    }

  }
  
  return storycontent
 }
//console.log(props.storyurl)

var cc = props.content ? placead() : null

return(
  <>
  <Helmet>
  <meta charSet="utf-8" />
  <title>{props.title}</title>
<link rel="canonical" href={props.storyurl} />
  <meta name="theme-color" content="#ffffff" />
     <meta name="_token" content="" />
     <meta name="robots" content="noodp" />
     <meta property="url" content={props.storyurl} />
     <meta property="title" content={props.title} />
     <meta property="quote" content={props.storyexcerpt} />
     <meta property="image" content={props.storyimage} />
     <meta property="og:type" content="website" />
     <meta property="og:quote" content={props.storyauthor} />
     { listvalue.map((taglst,i)=>{

return(<meta key={i} property="og:hashtag" content={taglst.name} />)


})}
     <meta content="image/*" property="og:image:type" />
     <meta property="og:site_name" content="MyJoyonline" />
     <meta property="og:description" content={props.storyexcerpt} /> 

  
  <meta property="og:locale" content="en_US" />
  <meta property="og:url" content={props.storyurl} />
  <meta property="article:publisher" content="https://web.facebook.com/JoyNewsOnTV/" />
{ listvalue.map((taglst,i)=>{

return(<meta key={i} property="article:tag" content={taglst.name} />)


})}
<meta property="og:title" content={props.title} />
<meta property="article:section" content="National" />
<meta property="og:updated_time" content={props.datepublished} />
<meta property="og:image" content={props.storyimage} />
<meta property="og:image:secure_url" content={props.storyimage} />
<meta property="og:image:width" content="1600" />
<meta property="og:image:height" content="1066" />
<meta property="og:image:alt" content={props.title} />
<meta property="og:image:type" content="image/jpeg" />
<meta property="article:published_time" content={props.datepublished} />
<meta property="article:modified_time" content={props.datepublished} />
<meta name="twitter:card" content="summary_large_image" />
<meta name="twitter:title" content={props.title} />
<meta name="twitter:description" content={props.storyexcerpt} />
<meta name="twitter:site" content="@joyonlineghana" />
<meta name="twitter:creator" content="@joyonlineghana" />
<meta name="twitter:image" content={props.storyimage} />
<meta name="twitter:label1" content="Written by" />
<meta name="twitter:data1" content={props.storyauthor} />
<meta name="twitter:label2" content="Time to read" />
<meta name="twitter:data2" content="1 minute" />

  </Helmet>
    <Chartbeat page="article" category ={props.category} author={props.storyauthor} />
    <div id="storytop" style={{ position: "relative",zIndex:"0", backgroundColor: "#ffffff", borderRadius:"20px", padding:"5px", marginBottom:"40px", marginTop:"0px", paddingTop:"5px" }}>
<article>


   
   <div className="article-title">
   <h1 style={{fontSize: "22px", marginBottom:"0px"}}>{props.title}</h1>
   </div>
   <div style={{color:"rgb(151 146 146)", fontSize:"12px", margin:"10px 0px", display:"flex", justifyContent:"space-between"}}><span>Source: {props.source}</span><span>{dpub(props.datepublished)}</span></div>
   { 
   <div className="interactiveicons" style={interactiveStyle}>
   {/* <ShareButtons title={props.title} url={baseurl+"/"+props.storyurl.slice(0,props.storyurl.length-1)} twitterHandle={"_MsLinda"} tags={listvalue}/> */}
   <SocialSharing title={props.title} url={baseurl+"/"+props.storyurl} tags={listvalue} />
   </div>
}
   
  { props.storyimage && <img src={props.storyimage} style={{width:"100%", marginBottom:"10px"}} alt={props.title} />}
   {/* <Trinity id={"audio"} /> */}
   { 
   
   <InArticlead id="myjoyonline_in_article_wrap" slot="/1002554/Myjoyonline/myjoyonline_in_article_wrap"  style={"left"} />

}

<SingleContent htmlContent={props.content} />

<div className="tagLabel">{
                   listvalue.map((lst,index) =>( <Link key={index} to={{pathname:"/tag/"+lst.slug, state:{tagname:lst.name,tagslug:lst.slug}}}>{lst.name}</Link>))

                   
  }</div>


<div style={{color:"#999999", fontSize:"12px", margin:"20px auto", fontFamily:"times new roman"}}>
<strong>"DISCLAIMER</strong>: The Views, Comments, Opinions, Contributions and Statements made by Readers and Contributors on this platform do not necessarily represent the views or policy of Multimedia Group Limited."
</div>

 {/* !error && !loading && items.length > 0 &&
      <Recommended items={items} /> */}
      

<Subcategory category={props.catchildren} parent={props.parentname} />



<div id='vuukle-comments'></div>
<div class='vuukle-powerbar'></div>
<div id={props.guid}></div>

   {

    <OutbrainWidget dataSrc={"myjoyonline.com"} dataWidgetId="GS_1" />
    /*<Outbrain storyurl={props.storyurl} slug={props.slug} widgetid={"GS_1"} />*/
   }
   </article>
</div>
</>

)

})

export default StoryItem;